<!--RBW_20260604 - The cog is projected into the banner via the [headerActions] ng-content slot so it sits inside the blue bar to the right of the Upload Template button-->
<app-page-comp-header #pageheader
  [button0Show]="titlesEmbedButtons"
  button0Text="Create Template"
  [button1Show]="titlesEmbedButtons"
  button1Text="Upload Template"
  [initialCompanyId]="filterCompanyID"
  [showCancelButton]="showCancelButton"
  [showCompanyDropdown]="titlesEmbedCompanyDropDown"
  [showBulkOrderDropdown]="titlesEmbedBulkOrderDropDown"
  [title]="title"
  (button0Click)="CreateTemplateButtonClick()"
  (button1Click)="UploadTemplateButtonClick()"
  (companyDropDownChange)="companyDropDownOnChange($event)"
  (bulkOrderDropDownChange)="bulkOrderDropDownOnChange($event)"
  (cancelButtonOnClick)="closeForm()"
>
  <div headerActions ngbDropdown placement="bottom-end">
    <button type="button" class="btn btn-sm p-1 border-0 bg-transparent" ngbDropdownToggle title="Configure" style="line-height:1;">
      <i class="ri-settings-3-line text-white" style="font-size:1.875rem;"></i>
    </button>
    <div ngbDropdownMenu>
      <button ngbDropdownItem (click)="onViewSmsTemplateClick()">
        <i class="ri-chat-1-line me-2"></i>View SMS Text
      </button>
      <button ngbDropdownItem (click)="onViewEmailTemplateClick()">
        <i class="ri-mail-line me-2"></i>View Email Text
      </button>
    </div>
  </div>
</app-page-comp-header>

<div class="row">
  <div class="col-12">
    <div class="alert alert-info border-0 bulk-provision-instructions d-flex align-items-start" role="alert">
      <i class="ri-information-line me-2 fs-5"></i>
      <div class="flex-grow-1 bulk-provision-instructions-body">
        <div class="row">
          <div class="col-lg-8">
            <strong>Bulk provision new connections</strong>
            @if (!instructionsCollapsed) {
              <span> - provision multiple new connections at once from a single spreadsheet, rather than one at a time.</span>
              <ol class="mb-0 ps-3 mt-1">
                <li>Select the company you are provisioning for.</li>
                <li>Click <strong>Create Template</strong> and add one row per connection.</li>
                <li>Click <strong>Upload Template</strong> to import - rows appear in the grid below, with any validation issues highlighted to correct.</li>
                <li>When the rows are valid, click <strong>Bulk Provision</strong> to provision the new connections.</li>
              </ol>
            }
          </div>
          @if (!instructionsCollapsed) {
            <div class="col-lg-4 mt-2 mt-lg-0">
              <strong>Legend</strong>
              <ul class="list-unstyled mb-0 mt-1">
                <li class="d-flex align-items-start mb-1">
                  <span class="bulk-provision-legend-swatch bulk-provision-legend-greyed me-2"></span>
                  <span>Greyed cell - not required for this row; hover the cell for details.</span>
                </li>
                <li class="d-flex align-items-start">
                  <span class="bulk-provision-legend-swatch bulk-provision-legend-invalid me-2"></span>
                  <span>Red outline - a validation error; hover the cell for details, use edit to correct the value.</span>
                </li>
              </ul>
            </div>
          }
        </div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-link text-decoration-none p-0 ms-2 flex-shrink-0"
        (click)="toggleInstructions()"
        [attr.aria-expanded]="!instructionsCollapsed"
        [title]="instructionsCollapsed ? 'Show instructions' : 'Hide instructions'"
      >
        <i class="fs-5" [ngClass]="instructionsCollapsed ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'"></i>
      </button>
    </div>
  </div>
</div>

@if (!titlesEmbedButtons || !titlesEmbedCompanyDropDown || !titlesEmbedBulkOrderDropDown) {
  <div class="row g-4">
    <div style="display: flex; justify-content: space-between; margin-bottom: 1em;">
      <div class="col-5">
        <div class="row g-4">
          @if (!titlesEmbedButtons) {
            <div class="col-sm-auto">
              <div>
                <button type="button" class="btn btn-success" id="reservebtn" #bulkbtn (click)="CreateTemplateButtonClick()">Create Template</button>
              </div>
            </div>
          }
          @if (!titlesEmbedButtons) {
          <div class="col-sm-auto">
            <div>
              <button type="button" class="btn btn-success" id="bulkorderbtn" #bulkorderbtn (click)="UploadTemplateButtonClick()">Upload Template</button>
            </div>
          </div>
          }
        </div>
      </div>
      <div class="col-1">
      </div>
      <div class="col-3">
        @if (!titlesEmbedCompanyDropDown) {
          <app-dropdown-company
            [initialCompanyId]="filterCompanyID"
            (selectOnChangeEvent)="companyDropDownOnChange($event)"
          ></app-dropdown-company>
        }
      </div>
      <div class="col-3">
        @if (!titlesEmbedBulkOrderDropDown) {
          <app-dropdown-orders-bulk
            [initialCompanyId]="filterCompanyID"
            (selectOnChangeEvent)="bulkOrderDropDownOnChange($event)"
          ></app-dropdown-orders-bulk>
        }
      </div>
    </div>
  </div>
}

<input id="file-selector" #fileInput type="file" (change)="uploadData($event)" name="uploadExcel" style="display: none;">
<div *ngIf="showUploadMessages == true" class="row">
  <div class="col-12">
    <div class="mb-3">
      <div class="alert border-0 upload-messages {{alertColourInvalid}}" role="alert">
        <strong>{{uploadTitle}}</strong>
        <ul>
          <li *ngFor="let message of this.uploadMessages">
            {{ message }}
          </li>
        </ul>
      </div>
    </div>
    <button
      aria-label="Close"
      class="btn-close position-absolute top-0 end-0 m-3"
      id="close-messages"
      type="button"
      (click)="hideUploadMessagesButtonClick()"
    >
    </button>
  </div>
</div>

<!-- <div class="row g-4">
  <div style="display: flex; justify-content: space-between; margin-bottom: 1em;">
    <div class="col-4">
      <div class="row g-4">
        <div class="col-sm-auto">
          <div>
            <button type="button" class="btn btn-success" id="createtemplatebtn" #createtemplatebtn (click)="CreateTemplateButtonClick()">Create Template</button>
          </div>
        </div>
        <input id="file-selector" #fileInput type="file" (change)="uploadData($event)" name="uploadExcel" style="display: none;">
        <div class="col-sm-auto">
          <div>
            <button type="button" class="btn btn-success" id="uploadtemplatebtn" #uploadtemplatebtn (click)="UploadTemplateButtonClick(fileInput)">Upload Template</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1">
    </div>
    <div class="col-3">
      <app-dropdown-company
        [initialCompanyId]="filterCompanyID"
        (selectOnChangeEvent)="companyDropDownOnChange($event)"
      ></app-dropdown-company>
    </div>
    <div class="col-3">
      <app-dropdown-orders-bulk
        [initialCompanyId]="filterCompanyID"
        (selectOnChangeEvent)="bulkOrderDropDownOnChange($event)"
      ></app-dropdown-orders-bulk>
    </div>
  </div>
</div> -->

<div class="row g-3 mb-3">
  @for (stat of sureSimStatData; track $index) {
    <div class="col-xl-2 col-md-6">
      <app-stat-tile
        [accentColour]="stat.iconColour ?? 'primary'"
        [caption]="progressCaption(stat)"
        class="h-100 d-block"
        [decimalPlaces]="stat.decimalPlaces ?? 0"
        [icon]="stat.showSpinner ? 'bx bx-loader-alt bx-spin' : 'bx ' + stat.icon"
        [label]="stat.title ?? ''"
        [loading]="stat.loading"
        [value]="stat.value"
      >
        @if (progressPercent(stat) !== null) {
          <div statTileBottom class="progress rounded-0" style="height: 6px;">
            <div class="progress-bar bg-warning" role="progressbar" [style.width.%]="progressPercent(stat)"></div>
          </div>
        }
      </app-stat-tile>
    </div>
  }
</div>

<app-grid-view #gridView
[apiPath]="dgApiPath"
[dgActionColumn]="dgActionColumn"
[dgColumns]="dgColumns"
[dgPopup]="dgPopup"
[dgProperties]="dgProperties"
[dgTabs]="dgTabs"
(addButtonClick)="gridAddButtonClick($event)"
(checkbox0Change)="onCheckboxChange($event)"
(deleteButtonClick)="confirmDelete($event)"
(cellClick)="cellClick($event)"
(contentReady)="gridContentReady($event)"
(editButtonClick)="gridEditClick($event)"
(moreButtonClick)="gridMoreClick($event)"
(rowClick)="gridRowClick($event)"
(tabChanged)="onTabChange($event)"
></app-grid-view>

<div style="display: flex; justify-content: space-between; margin-top: 0.5rem; margin-bottom: 1em;">
  <h4 class="card-title mb-0"></h4>
  <div class="row g-4">
    <div class="col-sm-auto">
      <div>
        <button type="button" class="btn btn-danger" #bulkbtn [disabled]="!deleteButtonEnabled" (click)="BulkDeleteButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Delete all unprocessed orders in this bulk order.">Bulk Delete<span class="badge bg-light text-dark ms-1">{{ bulkDeleteCount }}</span></button>
      </div>
    </div>
    <div class="col-sm-auto" *ngIf="updateInviewButtonVisible">
      <div>
        <button type="button" class="btn btn-success" (click)="UpdateInviewToMatchButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Retire Inview mobiles held against a different user in this company, so the numbers can be registered against the users in this bulk order.">Bulk retire Inview mobiles<span class="badge bg-light text-dark ms-1">{{ updateInviewCount }}</span></button>
      </div>
    </div>
    <div class="col-sm-auto" *ngIf="createUsersButtonVisible">
      <div>
        <button type="button" class="btn btn-success" (click)="CreateUsersOnlyButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Create user records for the valid rows that don't yet have a user, without provisioning any SIMs.">Create users<span class="badge bg-light text-dark ms-1">{{ createUsersCount }}</span></button>
      </div>
    </div>
    <div class="col-sm-auto" *ngIf="reserveSimsButtonVisible">
      <div>
        <button type="button" class="btn btn-success" (click)="ReserveSimsButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Reserve physical SIM ICCIDs to this company so they can be provisioned.">Bulk reserve SIMs<span class="badge bg-light text-dark ms-1">{{ reserveSimsCount }}</span></button>
      </div>
    </div>
    <div class="col-sm-auto" *ngIf="sendManualActivationButtonVisible">
      <div>
        <button type="button" class="btn btn-success" (click)="SendManualActivationButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="An Email will be sent to you containing all the activation details for the manually-provisioned SIMs in this bulk order.">Send manual activation<span class="badge bg-light text-dark ms-1">{{ manualActivationCount }}</span></button>
      </div>
    </div>
    <div class="col-sm-auto" *ngIf="clearErrorsButtonVisible">
      <div>
        <button type="button" class="btn btn-warning" (click)="ClearErrorsButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Clear the error on failed rows so they can be provisioned again by the next Bulk Provision.">Clear Errors<span class="badge bg-light text-dark ms-1">{{ bulkClearErrorsCount }}</span></button>
      </div>
    </div>
    <div class="col-sm-auto" *ngIf="provisioningIsRunning">
      <div>
        <button type="button" class="btn btn-warning" (click)="StopProvisioningButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Stand down any remaining entries. Any entry already being provisioned will still complete.">Stop Provisioning</button>
      </div>
    </div>
    <div class="col-sm-auto">
      <div>
        <button type="button" class="btn btn-info" #bulkbtn [disabled]="!provisionButtonEnabled" (click)="BulkProvisionButtonClick()"
                container="body" placement="top-end top auto" triggers="hover" tooltipClass="custom-tooltip-bulk"
                ngbTooltip="Provision all valid entries in this bulk order.">Bulk Provision<span class="badge bg-light text-dark ms-1">{{ bulkProvisionCount }}</span></button>
      </div>
    </div>
  </div>
</div>

<app-spinner-overlay-wrapper #spinnerOverlayWrapperComponent
    [showSpinner]="this.uploadInProgress"
></app-spinner-overlay-wrapper>

<app-completed-modal-nr-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-nr-form>

<app-confirmation-modal-nr-form #deleteConfirmationModal
  (modalYes)="yesDeleteBulkOrderEntry()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #deleteBulkConfirmationModal
  (modalYes)="yesDeleteBulkOrder()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #provisionBulkConfirmationModal
  (modalYes)="yesBulkProvision()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #clearErrorsConfirmationModal
  (modalYes)="yesClearErrors()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #updateInviewConfirmationModal
  (modalYes)="yesUpdateInviewToMatch()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #createUsersConfirmationModal
  (modalYes)="yesCreateUsersOnly()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #reserveSimsConfirmationModal
  (modalYes)="yesReserveSims()"
></app-confirmation-modal-nr-form>

<app-confirmation-modal-nr-form #sendManualConfirmationModal
  (modalYes)="yesSendManualActivation()"
></app-confirmation-modal-nr-form>


<app-warning-modal-form #warningModalForm
></app-warning-modal-form>